/* Glawning Help Centre: instant search, accordions, video, feedback */
(function () {
  if (window.__hcInit) return; window.__hcInit = true;
  var idx = null;
  function index() {
    if (idx) return idx;
    var el = document.getElementById('hc-index');
    try { idx = el ? JSON.parse(el.textContent) : []; } catch (e) { idx = []; }
    idx.forEach(function (d) { d._t = (d.t || '').toLowerCase(); d._k = (d.k || '').toLowerCase(); d._s = (d.s || '').toLowerCase(); d._c = (d.c || '').toLowerCase(); });
    return idx;
  }
  var STOP = { the:1, a:1, an:1, my:1, i:1, to:1, of:1, and:1, or:1, is:1, it:1, can:1, do:1, does:1, how:1, what:1, on:1, in:1, for:1, with:1, will:1, you:1 };
  function tokens(q) { return q.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(function (w) { return w && !STOP[w]; }); }
  function search(q) {
    var ts = tokens(q); if (!ts.length) return [];
    return index().map(function (d) {
      var score = 0, hit = 0;
      ts.forEach(function (w) {
        var s = 0;
        if (d._t.indexOf(w) > -1) s += 6;
        if (d._k.indexOf(w) > -1) s += 4;
        if (d._c.indexOf(w) > -1) s += 2;
        if (d._s.indexOf(w) > -1) s += 1;
        if (s) hit++; score += s;
      });
      if (hit === ts.length) score += 5;
      return { d: d, score: hit ? score : 0 };
    }).filter(function (r) { return r.score > 0; }).sort(function (a, b) { return b.score - a.score; }).slice(0, 8);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mark(s, ts) {
    var out = esc(s);
    ts.forEach(function (w) { if (w.length > 2) out = out.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
    return out;
  }
  function bind(box) {
    var input = box.querySelector('[data-hc-input]'), list = box.querySelector('[data-hc-results]'), go = box.querySelector('[data-hc-go]');
    var sel = -1, current = [];
    function render() {
      var q = input.value.trim();
      if (q.length < 2) { list.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
      current = search(q); sel = -1; var ts = tokens(q);
      if (!current.length) {
        list.innerHTML = '<div class="hc-noresult">No guides match "' + esc(q) + '". Try other words, or <a href="#hc-contact">ask us directly</a>.</div>';
      } else {
        list.innerHTML = current.map(function (r, i) {
          return '<a class="hc-result" role="option" id="hc-r-' + i + '" href="' + esc(r.d.u) + '"><small class="hc-result__topic">' + esc(r.d.c) + '</small><b>' + mark(r.d.t, ts) + '</b><small>' + mark(r.d.s, ts) + '</small></a>';
        }).join('');
      }
      list.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    function highlight() {
      var items = list.querySelectorAll('.hc-result');
      items.forEach(function (a, i) { a.setAttribute('aria-selected', i === sel ? 'true' : 'false'); });
      if (items[sel]) items[sel].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('input', render);
    input.addEventListener('focus', render);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = Math.min(sel + 1, current.length - 1); highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sel = Math.max(sel - 1, 0); highlight(); }
      else if (e.key === 'Enter') { var r = current[sel > -1 ? sel : 0]; if (r) { e.preventDefault(); location.href = r.d.u; } }
      else if (e.key === 'Escape') { list.hidden = true; }
    });
    if (go) go.addEventListener('click', function () { render(); var r = current[0]; if (r) location.href = r.d.u; else input.focus(); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) list.hidden = true; });
    box._hcSet = function (q) { input.value = q; input.focus(); render(); box.scrollIntoView({ block: 'center', behavior: 'smooth' }); };
  }
  function init() {
    var boxes = document.querySelectorAll('[data-hc-search]');
    boxes.forEach(bind);
    var main = boxes[0];
    document.querySelectorAll('[data-hc-chip]').forEach(function (c) {
      c.addEventListener('click', function (e) { if (!main) return; e.preventDefault(); main._hcSet(c.getAttribute('data-hc-chip')); });
    });
    var m = location.hash.match(/^#q=(.+)$/);
    if (m && main) main._hcSet(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    document.querySelectorAll('[data-hc-toggle-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wrap = document.getElementById(b.getAttribute('data-hc-toggle-all')); if (!wrap) return;
        var ds = wrap.querySelectorAll('details'), open = b.getAttribute('data-open') !== 'true';
        ds.forEach(function (d) { d.open = open; });
        b.setAttribute('data-open', open); b.textContent = open ? 'Collapse all' : 'Expand all';
      });
    });
    if (location.hash && location.hash.indexOf('#q=') !== 0) {
      try { var d = document.querySelector(location.hash); if (d && d.tagName === 'DETAILS') { d.open = true; d.scrollIntoView({ block: 'start' }); } } catch (e) {}
    }
    document.querySelectorAll('[data-hc-video]').forEach(function (v) {
      var btn = v.querySelector('button'); if (!btn) return;
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + v.getAttribute('data-hc-video') + '?autoplay=1&rel=0';
        f.title = 'Glawning video'; f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen = true;
        v.innerHTML = ''; v.appendChild(f);
      });
    });
    document.querySelectorAll('[data-hc-feedback]').forEach(function (w) {
      w.querySelectorAll('[data-hc-fb]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-hc-fb');
          w.querySelector('.hc-feedback__btns').hidden = true; w.querySelector('.hc-feedback__q').hidden = true;
          w.querySelector('[data-hc-fb-' + v + ']').hidden = false;
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('help_article_feedback', { helpful: v, page: location.pathname }); } catch (e) {}
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
